export const DAMAGE_PARTS = ['body', 'head', 'shoulderLeft', 'shoulderRight', 'armLeft', 'armRight', 'handLeft', 'handRight', 'belly', 'thighLeft', 'thighRight', 'legLeft', 'legRight', 'feetLeft', 'feetRight'];

// Centre-to-centre limits exceed the connected limbs' full reach (plus packet
// rounding slack). Only cosmetic separation is inferred; gameplay stays local.
const links = [[0, 1, 110], [0, 2, 80], [0, 3, 80], [2, 4, 85], [3, 5, 85], [4, 6, 70], [5, 7, 70], [0, 8, 85], [8, 9, 90], [8, 10, 90], [9, 11, 110], [10, 12, 110], [11, 13, 80], [12, 14, 80]];
const clampVelocity = value => Math.max(-700, Math.min(700, value));

export class RemoteDamage {
	constructor() {
		this.positions = new Float64Array(DAMAGE_PARTS.length * 4);
		this.alive = 0;
		this.severed = 0;
		this.initialized = false;
		this.impact = {x: 0, y: 0};
	}

	update(owner, effects, time, reset = false) {
		const dt = (time - this.time) / 1000;
		const silent = reset || !this.initialized || dt > 0.5;
		if (silent) this.severed = 0;
		let alive = 0;
		let impact = null;
		for (let i = 0; i < DAMAGE_PARTS.length; i++) {
			const key = DAMAGE_PARTS[i];
			const state = owner.state[key];
			const offset = i * 4;
			const wasAlive = (this.alive & (1 << i)) !== 0;
			if (state.destroyed) {
				if (!silent && wasAlive && effects.burst(owner, key, this.positions[offset], this.positions[offset + 1], this.positions[offset + 2], this.positions[offset + 3])) {
					this.impact.x = this.positions[offset];
					this.impact.y = this.positions[offset + 1];
					impact = this.impact;
				}
				continue;
			}
			alive |= 1 << i;
			const x = owner.state.body.x + (i === 0 ? 0 : state.x);
			const y = owner.state.body.y + (i === 0 ? 0 : state.y);
			this.positions[offset + 2] = !silent && wasAlive && dt > 0 ? clampVelocity((x - this.positions[offset]) / dt) : 0;
			this.positions[offset + 3] = !silent && wasAlive && dt > 0 ? clampVelocity((y - this.positions[offset + 1]) / dt) : 0;
			this.positions[offset] = x;
			this.positions[offset + 1] = y;
		}
		for (let i = 0; i < links.length; i++) {
			if (this.severed & (1 << i)) continue;
			const [a, b, reach] = links[i];
			const aAlive = alive & (1 << a), bAlive = alive & (1 << b);
			const dx = this.positions[a * 4] - this.positions[b * 4];
			const dy = this.positions[a * 4 + 1] - this.positions[b * 4 + 1];
			if (aAlive && bAlive && dx * dx + dy * dy <= reach * reach) continue;
			this.severed |= 1 << i;
			if (silent) continue;
			if (aAlive) effects.bleed(owner, DAMAGE_PARTS[a]);
			if (bAlive) effects.bleed(owner, DAMAGE_PARTS[b]);
			if (aAlive && bAlive) effects.burst(owner, DAMAGE_PARTS[b], this.positions[b * 4], this.positions[b * 4 + 1], this.positions[b * 4 + 2], this.positions[b * 4 + 3], true);
		}
		this.alive = alive;
		this.initialized = true;
		this.time = time;
		return impact;
	}
}
